/** For use with react-dnd */
export enum DraggableType {
  /** Expects an `id` field to be provided */
  MEDIA_MANAGER_GALLECTION = 'mm-gallection',
  MEDIA_MANAGER_SLIDER_GALLECTION = 'mm-slider-gallection',
  MEDIA_MANAGER_DEVIATION = 'mm-deviation',

  /** Expects a `deviation` field to be provided */
  DEVIATION = 'deviation',

  /** Expects an `id` field to be provided */
  BADGE = 'badge',
  BADGE_FEATURED = 'badgefeatured',

  /** Expects an `id` field to be provided */
  STUDIO_TABLE_ROW = 'studio_table_row',

  STUDIO_PREVIEW_THUMB = 'studio_preview_thumb',
  STUDIO_FOLDER = 'studio_folder',
  STUDIO_GRID_ITEM = 'studio_grid_item',
  STUDIO_BOOKMARK = 'studio_bookmark',
}

// TODO: Figure out a decent way to type DND payloads
